export default function mapperToIssInformationRequest(formData, requestAction) {
  return {
    "Ação da solicitação": requestAction,
    Cidade: formData.city,
    "Id da Cidade": formData.cityId,
    "Pago Conta Florianópolis": formData.paySingleQuotaValue ? "Sim" : "Não",
  };
}
